import { createStyles, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    var _a;
    return createStyles({
        thumb: {
            '&$open': {
                '& $offset': (_a = {
                        transform: 'scale(1) translateY(54px)'
                    },
                    _a[theme.breakpoints.down('sm')] = {
                        transform: 'scale(1) translateY(61px)',
                    },
                    _a),
            },
        },
        open: {},
        offset: {
            zIndex: 1,
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 700,
            lineHeight: 1.2,
            transition: theme.transitions.create(['transform'], {
                duration: theme.transitions.duration.shortest,
            }),
            top: -34,
            transformOrigin: 'bottom center',
            transform: 'scale(0)',
            position: 'absolute',
        },
        circle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 32,
        },
        label: {
            color: theme.palette.primary.main,
        },
    });
});
export default useStyles;
